import { get } from 'lodash';
import React from 'react';
import { ShefRatingChip } from 'src/shared/design-system/DishFirstShefCard/ShefRatingChip';
import { BaseCard } from './BaseCard';
import { useShefCard } from './hooks';
import { LoadingRating, LoadingShefImage, LoadingSubTitle, LoadingTitleHalf } from './styles';
import { ShefCardProps } from './types';

export const ShefCard: React.FC<ShefCardProps> = (props) => {
  const { shefResult } = props;
  const cardProps = useShefCard(props);

  return (
    <BaseCard
      {...cardProps}
      rating={
        shefResult.rating?.score && shefResult.rating?.count ? (
          <ShefRatingChip
            averageRating={get(shefResult, 'rating.score')}
            count={get(shefResult, 'rating.count')}
            showAsFiveStar
          />
        ) : undefined
      }
    />
  );
};

export const LoadingShefCard = () => (
  <BaseCard
    image={<LoadingShefImage />}
    title={<LoadingTitleHalf />}
    subtitle={<LoadingSubTitle />}
    rating={<LoadingRating />}
  />
);
